import { Package } from "lucide-react";
import { formatINR, priceOf } from "@/config";
import { comboItemIssue } from "@/lib/combo";
import { ProductOptionsFields } from "./ProductOptionsFields";

export const ComboProducts = ({ members, quote, cart, choices, onChoice }) => (
  <ul data-testid="combo-preview-products" className="divide-y divide-white/10">
    {members.map((member) => {
      const { id, product, qty } = member;
      const issue = comboItemIssue(member, cart);
      const unitPrice = quote?.items.find((item) => item.product_id === id)?.price ?? priceOf(product);
      return (
        <li key={id} data-testid={`combo-preview-product-${id}`} className="min-w-0 py-5">
          <div className="flex min-w-0 gap-4">
          <div className="h-24 w-20 shrink-0 overflow-hidden rounded-lg bg-white sm:h-28 sm:w-24">
            {product && product.is_live !== false ? (
              <img
                data-testid={`combo-preview-image-${id}`}
                src={product.image || "/placeholder-product.svg"} alt={product.name}
                onError={(event) => { event.currentTarget.onerror = null; event.currentTarget.src = "/placeholder-product.svg"; }}
                className="h-full w-full object-contain"
              />
            ) : (
              <div className="flex h-full items-center justify-center bg-[#181B24] text-slate-400"><Package size={28} aria-hidden="true" /></div>
            )}
          </div>
          <div className="min-w-0 flex-1 [overflow-wrap:anywhere]">
            <p data-testid={`combo-preview-name-${id}`} className="font-display text-base font-semibold text-white">{product?.name || "Unavailable product"}</p>
            {product?.sku && <p data-testid={`combo-preview-code-${id}`} className="mt-1 font-mono text-xs text-cyan-300">Code {product.sku}</p>}
            <div className="mt-3 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 text-sm">
              <span data-testid={`combo-preview-quantity-${id}`} className="text-slate-300">Qty {qty}{product ? ` × ${formatINR(unitPrice)}` : ""}</span>
              {product && <span data-testid={`combo-preview-line-total-${id}`} className="font-semibold text-slate-100">{formatINR(unitPrice * qty)}</span>}
            </div>
            {issue && <p data-testid={`combo-preview-availability-${id}`} className="mt-2 text-xs text-rose-300">{issue}</p>}
          </div>
          </div>
          {product && <div className="mt-4"><ProductOptionsFields product={product} sizes={choices[id]?.size_quantities || {}} details={choices[id]?.details ?? cart.find((item) => item.product.id === id)?.details ?? ""} prefix={`combo-product-${id}`} requiredQty={qty} disabled={!!issue} onSizes={(size_quantities) => onChoice(id, { size_quantities })} onDetails={(details) => onChoice(id, { details })} /></div>}
        </li>
      );
    })}
  </ul>
);